import vuetifyToast from 'vuetify-toast'
import { apiAxios } from '@/helpers'
const notify = (message, type) => {
  vuetifyToast.show({
    text: message,
    color: type || 'success',
    timeout: 3000,
    icon: 'check',
  })
}
export const baseActions = {
  async getOne({ commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${id}?formatTypePayments=true&isAll=true`)
      .finally(() => commit('setLoading', false))
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async fetchOne({ commit, dispatch }, id) {
    let item = await dispatch('getOne', id)
    commit('setOne', item)
    return item
  },
  async fetchList({ commit, state }, params = {}) {
    let set = true
    if (params.set === false) {
      set = false
      delete params.set
    }
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params)
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }
    if (state.pagination.sortBy) {
      query.sort = {
        [state.pagination.sortBy]: state.pagination.descending ? -1 : 1,
      }
      delete body.page
    }
    if (state.selected.active !== undefined) body.active = 'all'
    if (state.filters && typeof state.filters === 'object') {
      Object.keys(state.filters).forEach((key) => {
        if (state.filters[key] !== '' && state.filters[key] !== undefined) {
          body[key] = state.filters[key]
        }
      })
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module, body, { params: { ...query } })
      .finally(() => commit('setLoading', false))
    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    if (set) commit('setList', list)
    return list
  },
  async fetchSelectList({ commit, state }, params = {}) {
    let query = {}
    let set = true
    if (params.set === false) {
      set = false
      delete params.set
    }
    if (params.limit !== undefined) {
      query.limit = params.limit
      delete params.limit
    }

    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/select', params, { params: { ...query } })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    if (set) commit('setSelectList', list)
    return list
  },
  async create({ dispatch, commit, state }, payload) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/create', payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('fetchList')
    let item
    if (data.data) {
      if (data.data[state.model]) item = data.data[state.model]
      else if (data.data.dataResponse && data.data.dataResponse[state.model])
        item = data.data.dataResponse[state.model]
    }
    return item
  },
  async update({ dispatch, commit, state }, payload) {
    commit('setLoading', true)
    const id = payload._id
    const { data } = await apiAxios
      .put(`${state.module}/${id}`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message, data.type)
    dispatch('fetchList')
    let item
    if (data.data) {
      if (data.data[state.model]) item = data.data[state.model]
      else if (data.data.dataResponse && data.data.dataResponse[state.model])
        item = data.data.dataResponse[state.model]
    }
    return item
  },
  async delete({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .delete(`${state.module}/${id}`)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('fetchList')
  },
  setOne({ commit }, payload) {
    commit('reset')
    commit('setOne', payload)
  },
  setFilters({ commit }, payload) {
    commit('setFilters', payload)
  },
  reset({ commit }) {
    commit('reset')
  },
  resetFilters({ commit }) {
    commit('resetFilters')
  },
  resetState({ commit }) {
    commit('resetList')
    commit('reset')
    commit('resetFilters')
    commit('resetPagination')
  },
}

export const baseMutations = {
  setOne(state, payload) {
    if (payload && typeof payload === 'object') {
      state.selected = payload
      state.idSelected = payload._id
    }
  },
  setList(state, payload) {
    state.list = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.list.push(item))
    }
  },
  setSelectList(state, payload) {
    state.selectList = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.selectList.push(item))
    }
  },
  resetList(state) {
    state.list = []
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setFilters(state, payload) {
    state.filters = payload
  },
  resetFilters(state) {
    state.filters = state.initialFilters ? { ...state.initialFilters } : {}
  },
  setPagination(state, payload) {
    if (payload) state.pagination = Object.assign({}, state.pagination, payload)
  },
  resetPagination(state) {
    state.pagination = {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    }
  },
}
